import * as singleSpa from "single-spa";
import microFrontendLayout from "./microfrontend-layout.html";
import { constructApplications, constructLayoutEngine, constructRoutes } from "single-spa-layout";
import { initializeWebSocket } from "./websocket.module";
import { initializeSessionEvent } from "./session-capture.module";
import { loadUserState } from "./user-state.module";
import { EventBus } from "@trutoo/event-bus";
import { initializeAmplitude } from "./amplitude.module";
import { initializeFS } from "./fullstory.module";
import { initializeUnauthorizedRedirect } from "./unauthorized-redirect.module";

window.addEventListener("single-spa:before-first-mount", async () => {
  window.eventBus = new EventBus();
  initializeUnauthorizedRedirect();
  initializeFS();
  initializeAmplitude();
  initializeSessionEvent();
  initializeWebSocket();
  loadUserState();
});

const routes = constructRoutes(microFrontendLayout);
const applications = constructApplications({
  routes,
  loadApp({ name }: { name: string }) {
    return System.import(name);
  },
});

// Delay starting the layout engine until the styleguide CSS is loaded
const layoutEngine = constructLayoutEngine({
  routes,
  applications,
  active: false,
});

// Wait for react (prevent MUI from loading without react)
Promise.all([
  System.import("react"),
  System.import("react-dom"),
]).then(() => {
  applications.forEach(singleSpa.registerApplication);

  layoutEngine.activate();
  singleSpa.addErrorHandler((err) => {
    const appName = err.appOrParcelName;
    if (singleSpa.getAppStatus(appName) === singleSpa.LOAD_ERROR) {
      const resolvedApp = System.resolve(appName);
      System.delete(resolvedApp);
      setTimeout(() => {
        System.import(resolvedApp)
          .then(() => singleSpa.triggerAppChange())
        // eslint-disable-next-line no-console
          .catch(() => console.error("failed to reload bundle: ", appName));
      }, 1000);
    }
  });
  singleSpa.start();
});
